import { UserType } from '@nextgen-web-framework/all';
import { CMSDataType } from './common';

export const checkNonNullArrayOrNonEmptyObject = (item: CMSDataType) =>
  // if the item is an array, check the length, else check that its not an empty object.
  (Array.isArray(item) && item.length > 0) || Object.keys(item).length > 0;

export const getAccountTypeData = (data: CMSDataType, accountType: string | undefined) => {
  const accountTypeData = data.find((item: CMSDataType) => item.account_type?.account_type === accountType);
  if (accountTypeData) {
    return accountTypeData;
  }
  const index = data.findIndex((item: CMSDataType) => item.account_type?.account_type === UserType.ANONYMOUS);
  if (index !== -1) {
    return data?.[index];
  }
  return data?.[0];
};
